import { useQuery } from 'react-query';
import { service } from '../redux/api/axios';

const useHook = (id: string) => {
  return useQuery(
    ['event_by_id_posts', id],
    async () => {
      const response = await service.get(`/events/${id}/posts`);
      return response.data;
    },
    { enabled: !!id }
  );
};

export default useHook;
